/* Kellyville Pets — Dog Coat Size Guide
   Lead-form handling: validation, GA4 + Meta Pixel events, inline thank-you state.
   In production, replace the native form with the Klaviyo embed and listen for
   Klaviyo's `klaviyoForms` submit event instead. The analytics block stays the same. */

(function () {
  'use strict';

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function showError(input, msg) {
    input.setAttribute('aria-invalid', 'true');
    var name = input.getAttribute('name');
    var err = input.form.querySelector('[data-error-for="' + name + '"]');
    if (err) err.textContent = msg;
  }

  function clearError(input) {
    input.removeAttribute('aria-invalid');
    var name = input.getAttribute('name');
    var err = input.form.querySelector('[data-error-for="' + name + '"]');
    if (err) err.textContent = '';
  }

  function validate(form) {
    var ok = true;
    var first = form.querySelector('[name="firstName"]');
    var email = form.querySelector('[name="email"]');

    [first, email].forEach(clearError);

    if (!first.value.trim()) { showError(first, 'Please enter your first name'); ok = false; }
    else if (first.value.trim().length > 60) { showError(first, 'Too long'); ok = false; }

    var ev = email.value.trim();
    if (!ev) { showError(email, 'Please enter your email'); ok = false; }
    else if (!EMAIL_RE.test(ev) || ev.length > 255) { showError(email, 'Please enter a valid email'); ok = false; }

    return ok;
  }

  function readProps(el) {
    if (!el) return {};
    var raw = el.getAttribute('data-kp-properties');
    if (!raw) return {};
    try { return JSON.parse(raw) || {}; } catch (e) { return {}; }
  }

  function pushKlaviyoIdentify(props, email) {
    if (!props || (!email && Object.keys(props).length === 0)) return;
    try {
      window._learnq = window._learnq || [];
      var payload = {};
      Object.keys(props).forEach(function (k) { payload[k] = props[k]; });
      if (email) payload.$email = email;
      window._learnq.push(['identify', payload]);
    } catch (e) { /* klaviyo not loaded */ }
  }

  function fireAnalytics(props) {
    var detail = Object.assign({ source: 'coat_size_guide' }, props || {});
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'generate_lead', detail);
      } else if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push(Object.assign({ event: 'generate_lead' }, detail));
      }
    } catch (e) { /* analytics not loaded */ }

    try {
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'Lead', detail);
      }
    } catch (e) { /* pixel not loaded */ }
  }

  function renderSuccess(form) {
    var coatsUrl = window.KP_COATS_URL || '/collections/dog-coats';
    form.classList.add('kp-form--success');
    form.innerHTML =
      '<div class="kp-form__success-icon" aria-hidden="true">' +
        '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21.8 10A10 10 0 1 1 17 3.3"/><path d="m9 11 3 3L22 4"/></svg>' +
      '</div>' +
      '<h3 class="kp-form__success-title">You\u2019re all set 🐾</h3>' +
      '<p class="kp-form__success-body">The Kellyville Pets Dog Coat Size Guide is on its way. ' +
      'Check your inbox in the next few minutes.</p>' +
      '<p class="kp-form__success-link">Ready to shop? ' +
      '<a href="' + coatsUrl + '">Browse our full range of dog coats →</a></p>';
    form.setAttribute('role', 'status');
    form.setAttribute('aria-live', 'polite');
  }

  function safeRedirect(url) {
    if (!url) return false;
    try {
      // Allow same-origin paths and absolute http(s) URLs only.
      var isPath = url.charAt(0) === '/';
      var isHttp = /^https?:\/\//i.test(url);
      if (!isPath && !isHttp) return false;
      window.location.assign(url);
      return true;
    } catch (e) { return false; }
  }

  function attach(form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!validate(form)) return;

      var btn = form.querySelector('button[type="submit"]');
      var label = form.querySelector('[data-kp-btn-label]');
      if (btn) btn.disabled = true;
      if (label) label.textContent = 'Sending\u2026';

      var props = readProps(form);
      var email = (form.querySelector('[name="email"]') || {}).value;
      var redirect = form.getAttribute('data-kp-redirect');

      // === KLAVIYO INTEGRATION POINT =========================================
      // Replace this setTimeout with a real fetch to your Klaviyo list endpoint
      // (Klaviyo client API). Custom properties from the section settings are
      // available in `props` and are also rendered as hidden properties[k] inputs.
      // ======================================================================
      setTimeout(function () {
        pushKlaviyoIdentify(props, email);
        fireAnalytics(props);
        if (safeRedirect(redirect)) return;
        renderSuccess(form);
      }, 500);
    });
  }

  // Klaviyo embedded forms — listen for their global submit event and push the
  // section's custom properties onto the profile via the onsite identify API.
  function attachKlaviyoListeners() {
    window.addEventListener('klaviyoForms', function (e) {
      if (!e || !e.detail) return;
      var type = e.detail.type;
      if (type !== 'submit' && type !== 'embedSubmit') return;

      // Find the wrapper this form belongs to and read its properties.
      var formEl = e.detail.formId
        ? document.querySelector('.klaviyo-form-' + e.detail.formId)
        : null;
      var wrapper = formEl ? formEl.closest('[data-kp-klaviyo-form]') : null;
      var props = readProps(wrapper);

      var email = '';
      try {
        var meta = e.detail.metaData || {};
        email = meta.$email || meta.email || '';
      } catch (err) { /* noop */ }

      pushKlaviyoIdentify(props, email);
      fireAnalytics(props);

      // Per-section redirect after successful Klaviyo embed submit.
      var redirect = wrapper ? wrapper.getAttribute('data-kp-redirect') : null;
      if (redirect) {
        // Small delay so Klaviyo can finish its own success step / network call.
        setTimeout(function () { safeRedirect(redirect); }, 400);
      }
    });
  }

  function init() {
    var forms = document.querySelectorAll('[data-kp-form]');
    Array.prototype.forEach.call(forms, attach);
    attachKlaviyoListeners();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
